module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAQBAMAAAAc1rnfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURV1dXUdwTF1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXbAMRPUAAAALdFJOU/8ATO+0is5aFCEs1ZllVgAAAAlwSFlzAAAASAAAAEgARslrPgAAAIlJREFUGNNjEAQCoZBkBjNXRRBTgAFILDVgAAHmKKhACwODSbhSqTMDgwdYQMiAwUlQKFRRUIWBWREkUMDgJSiRwMDWKLiEgR0oIMRgLigoBjQiUVCwmEFRgGEy20RBQQWgAJOgoGSCpQCDQwbQ7ACgACuQbmPBIoChBcNQDGsxHYbhdEzPoXofAKCEIQOwx6OyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/user/visible.png
// module id = 246
// module chunks = 0